<template>
  <div :class="['wl-hamburger-menu', {'open': isOpen}]" @click="handleClick">
    <span></span>
    <span></span>
    <span></span>
    <span></span>
  </div>

  <transition name="fade">
    <div v-if="isOpen" class="wl-menu">

      <ul class="wl-menu-list">
        <li v-for="link in links" :key="link.label">
          <a :href="link.url">{{ link.label }}</a>
        </li>
      </ul>

      <div class="wl-menu-footer">
        <a href="https://www.escapethecity.org" target="_blank" rel="noopener">
          <p class="wl-footer-text">Careers site powered by Escape the CIty</p>
          <img class="wl-logo" :src="`/images/escape-logo-white.svg?${$config.version}`" alt="Escape The City" loading="lazy">
        </a>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'WlMenu',

  props: {
    payload: {
      type: String
    }
  },

  data() {
    return {
      isOpen: false
    }
  },

  methods:{
    handleClick() {
      this.isOpen = !this.isOpen;
    }
  },

  computed: {
    links() {
      return JSON.parse(this.payload);
    }
  }
}
</script>
